export const HIGH_LEVEL_AXIS_HEIGHT = 56;
export const LOW_LEVEL_AXIS_HEIGHT = 50;
